@use "~theme/breakpoints";

.contentLeft {
    float:left;
    width: 55%;
    padding-left: 10px;
    padding-top: 10px;
}

.contentRight {
    float:right;
    width:45%;
    text-align: right;
    padding-right: 10px;
    padding-top: 10px;
}

.footerPhoneLink {
    white-space: nowrap;
}

.officeName {
    font-size: 16px;
    color: black;
    font-weight: 600;
    text-decoration-line: underline;
    @include breakpoints.desktop {
        font-size: 14px;
    }
    @include breakpoints.desktop-medium {
        font-size: 15px;
    }
    @include breakpoints.desktop-large {
        font-size: 16px; 
    }
}

.officeAddress {
    color: rgba(0, 0, 0, 0.7);
    font-size: 13px;
    font-weight: 400;
    @include breakpoints.desktop {
        font-size: 12px;
    }
    @include breakpoints.desktop-medium {
        font-size: 13px;
    }
    @include breakpoints.desktop-large {
        font-size: 14px; 
    }
}

.officePhone {
    color: #003366;
    font-size: 12px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0.02em;
}

.icon {
    margin-right: 5px;
    width: 16px;
    @include breakpoints.desktop {
        width: auto;
    }
}

.medicaid {
    color: #003366;
    font-size: 10px;
    font-weight: 400;
}

.timings {
    color: #003366;    
    font-size: 14px;
    font-weight: 600;
    line-height: 140%;
    letter-spacing: 0.02em;
    @include breakpoints.desktop {
        font-size: 12px;
        font-weight: 400;
    }
}

.nearbyContent {
    cursor: pointer;
    display: block;
    overflow: auto;
    box-shadow: 0px 2px 6px #eaeaea;
    margin: 7px 13px;
    padding-bottom: 7px;
    @include breakpoints.desktop {
        padding-bottom: 0px;
        margin: 0px;
        box-shadow: none;
    }
}

.contentHeader {
    background: #B6E2F5;
    border-radius: 4px 4px 0px 0px;
    height: 34px;
    align-items: center;
    display: flex;
    text-align: center;
    img {
        right: 6%;
        padding: 8px;
        @include breakpoints.desktop {
            padding: 8px;
        }
    }
    .miles {
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 140%;
        align-items: center;
        letter-spacing: 0.02em;
        text-transform: lowercase;
        color: var(--blue-01);
        width: 30%;
        float: left;
        text-align: left;
    }
    .examDetails {
        font-weight: 700;
        font-size: 13px;
        line-height: 15px;
        display: block;
        align-items: center;
        text-align: right;
        color: var(--blue-01);
        width: 70%;
        letter-spacing: -0.02em;
        margin-right: 10px;
        @include breakpoints.desktop {
            font-weight: 500;
        }
    }
}
.officeAddressContainer {
    display: flex;
    height: auto;
}
.totalSlots {
    border: 1px solid #5FC5F8;
    padding: 3px 5px;
    border-radius: 25px;
    background-color: #5FC5F8;
    float: right;
    img {
        width: 15px;
        height: 15px;
        padding: 0px;
        margin: 0px;
    }
}

.slotsContainer {
    padding: 10px;
    display: flex;
}

.slotAvailable {
    border: 1px solid black;
    border-radius: 5px;
    padding: 5px;
    width: 33%;
    float: right;
    margin-right: 10px;
    margin-bottom: 10px;
    font-size: 12px;
    text-align: center;
    @include breakpoints.desktop {
        width: 28%;   
    }
}

.slotIcon {
    width: 15px;
    height: 15px;
    padding: 0px;
    margin: 0px;
}

.morningSlotIcon {
    margin-top: -5px;
}